<template>
  <ApplicationLayout>
    <v-container
      fluid
      px-12
      py-6
      v-if="ready"
    >
      <BackTitle
        :to="{
          name: 'categories',
          query: { focus: category.id }
        }"
        :title="title"
        :subtitle="categoryName"
      ></BackTitle>

      <v-card
        class="pa-6 mt-6"
      >
        <v-row>
          <v-col
            cols="6"
            offset="3"
          >
            <v-form
              @submit.prevent="submit()"
              ref="form"
              v-model="valid"
            >
              <v-text-field
                v-model="category.name"
                label="Name"
                :rules="rules.name"
              ></v-text-field>

              <Combobox
                v-model="category.tags.included"
                :select-props="{
                  items: _tagsWithoutExcluded,
                  label: 'Tags',
                  chips: true,
                  deletableChips: true,
                  multiple: true
                }"
                @create-new-item="$store.dispatch('Tags/createAndAdd', { name: $event, tags: category.tags.included })"
              ></Combobox>

              <Combobox
                v-model="category.tags.excluded"
                :select-props="{
                  items: _tagsWithoutIncluded,
                  label: 'Excluded Tags',
                  chips: true,
                  deletableChips: true,
                  multiple: true
                }"
                @create-new-item="$store.dispatch('Tags/createAndAdd', { name: $event, tags: category.tags.excluded })"
              ></Combobox>

              <div class="d-flex">
                <v-spacer></v-spacer>

                <v-btn
                  :disabled="!valid"
                  color="primary"
                  type="submit"
                  class="mr-4"
                  depressed
                >Save</v-btn>

                <v-btn
                  :disabled="!valid"
                  color="primary"
                  @click="saveAndGoBack()"
                  depressed
                >Save & Go back</v-btn>
              </div>
            </v-form>
          </v-col>
        </v-row>
      </v-card>

      <ProductsList
        v-if="category.id"
        class="mt-12"
        title="Category products"
        :scope="{ categoryId: category.id }"
      ></ProductsList>
    </v-container>
  </ApplicationLayout>
</template>

<script>
import { mapState } from 'vuex'
import ApplicationLayout from '../components/layouts/ApplicationLayout.vue'
import Combobox from '../components/Combobox.vue'
import BackTitle from '../components/BackTitle.vue'
import ProductsList from '../components/ProductsList.vue'

export default {
  components: {
    ApplicationLayout,
    Combobox,
    BackTitle,
    ProductsList
  },
  data() {
    return {
      valid: false,
      ready: false,
      editMode: !!this.$route.params.id,
      rules: {
        name: [v => !!v || 'Name is required']
      }
    }
  },
  computed: {
    ...mapState('Categories', ['category', 'categoryName']),
    ...mapState('Tags', ['tags']),
    _tagsWithoutIncluded() {
      return this.tags
        .filter(tag => !this.category.tags.included.includes(tag.id))
        .map(tag => ({
          text: tag.name,
          value: tag.id
        }))
    },
    _tagsWithoutExcluded() {
      return this.tags
        .filter(tag => !this.category.tags.excluded.includes(tag.id))
        .map(tag => ({
          text: tag.name,
          value: tag.id
        }))
    },
    title() {
      return this.editMode ? 'Category' : 'Create new category'
    }
  },
  async created() {
    await this.getCategory(this.$route.params.id)
    this.$store.dispatch('Tags/getAll')
    this.ready = true
  },
  methods: {
    async getCategory(id) {
      await this.$store.dispatch('Categories/get', id)
    },
    async submit() {
      if (!this.$refs.form.validate()) return
      const snackbar = { text: 'Category update succeed' }
      try {
        await this.$store.dispatch('Categories/createOrUpdate')
        if (!this.editMode) {
          this.$router.push({ name: 'category', params: { id: this.category.id } })
          snackbar.text = 'Category creation succeed'
          this.editMode = true
        }
      } catch (error) {
        snackbar.text = this.editMode ? 'Category update failed' : 'Category creation failed'
        snackbar.color = 'error'
      }
      this.$store.commit('Global/setSnackbar', snackbar)
    },
    async saveAndGoBack() {
      await this.submit()
      this.$router.push({ name: 'categories' })
    }
  },
  async beforeRouteUpdate(to, from, next) {
    if (to.name === from.name && to.params.id !== from.params.id) {
      await this.getCategory(to.params.id)
    }
    next()
  },
  beforeRouteLeave(to, from, next) {
    if (from.name !== 'new-category') {
      this.$store.commit('Categories/setCategory', null)
      this.$store.commit('Products/setProducts', null)
    }
    next()
  }
}
</script>
